
import { Component, Prop, Vue ,Model ,Watch } from "vue-property-decorator";
import Dialog from '@/components/dialog.vue';
import {
  authpcChangePassWord
} from "@/api/user"
import {
		removeUserId,
		removeUserInfo
	} from '@/utils/storage'
@Component({
    name: 'step-component',
    components: {
      'slz-dialog': Dialog,
    }
})
export default class StepComponent extends Vue {
  @Prop() showDialog!:boolean;
  @Prop({
    default:false
  }) canclose!:boolean;
  private show:boolean = false;
  private changeMsg:any = {
    oldpsd:'',
    newpsd:'',
    againpsd:''
  }
  @Watch('showDialog')
  private isShow(val:boolean){
    this.show = val
  }

  private confirm(){
    if(!this.changeMsg.oldpsd){
      this.$message.error('请输入旧密码')
      return 
    }else if(!this.changeMsg.newpsd){
      this.$message.error('请输入新密码')
      return 
    }else if(this.changeMsg.newpsd.length < 6){
      this.$message.error('请设置不低于6位数的登录密码')
      return 
    }else if(this.changeMsg.newpsd == this.changeMsg.oldpsd){
      this.$message.error('修改前后密码一致')
      return 
    }else if(this.changeMsg.newpsd != this.changeMsg.againpsd){
      this.$message.error('两次新密码不一致')
      return 
    }
    this.changePsd()
  }

  private async changePsd(){
    try{
      let res = await authpcChangePassWord({
        PassWord:this.changeMsg.oldpsd,
        NewPassWord:this.changeMsg.newpsd,
      })
      if(res.IsSuccess){
        this.$message.success('修改成功，请使用新密码登录')
        setTimeout(()=>{
          removeUserId();
          removeUserInfo();
          location.reload()
        },2000)
      }
    }finally{
      //
    }
  }




  private close(){
    this.changeMsg = {
      oldpsd:'',
      newpsd:'',
      againpsd:''
    }
    this.$emit('close')
  }



}
